// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-search-box-padding: 3px;
  --theia-search-box-radius: 2px;
  --theia-search-box-spacing: 4px;
  --theia-search-box-max-width: 500px;
}

.theia-search-box {
  position: absolute;
  display: flex;
  top: var(--theia-search-box-spacing);
  right: var(--theia-search-box-spacing);
  box-shadow: var(--theia-border-width) var(--theia-border-width)
    var(--theia-widget-shadow);
  background-color: var(--theia-listFilterWidget-background);
  z-index: calc(var(--theia-tabbar-toolbar-z-index) + 1);
  border-radius: var(--theia-search-box-radius);
  padding: var(--theia-search-box-padding);
  border: var(--theia-border-width) solid rgba(0, 0, 0, 0);
}

.theia-search-box.no-match {
  border: var(--theia-border-width) solid
    var(--theia-inputValidation-errorBorder);
}

.theia-search-input {
  flex-grow: 1;
  user-select: none;
}

.theia-search-box > .theia-search-buttons-wrapper {
  max-width: 0px;
  transition: max-width 0.2s ease-out;
  display: flex;
  box-sizing: border-box;
  align-items: center;
}

.theia-search-box:hover > .theia-search-buttons-wrapper {
  max-width: var(--theia-search-box-max-width);
  transition: max-width 0.2s ease-in;
}

.theia-search-button {
  min-width: 1rem;
  text-align: center;
  flex-grow: 0;
  font-family: FontAwesome;
  font-size: calc(var(--theia-content-font-size) * 0.8);
  color: var(--theia-editorWidget-foreground);
}

.theia-search-button.codicon.codicon-filter {
  color: var(--theia-editorWidget-foreground);
  align-self: flex-end;
  margin-left: var(--theia-search-box-spacing);
}

.theia-search-button.codicon-filter:not(.filter-active):before {
  content: "\\eb85";
}

.theia-search-button.codicon-filter.filter-active:before {
  content: "\\eb83";
}

.theia-search-button-next:before {
  content: "\\f107";
}

.theia-search-button-next:hover,
.theia-search-button-previous:hover,
.theia-search-button-close:hover,
.theia-search-button.codicon-filter:hover {
  cursor: pointer;
}

.theia-search-button-next:hover:before {
  content: "\\f107";
}

.theia-search-button-previous:before {
  content: "\\f106";
}

.theia-search-button-previous:hover:before {
  content: "\\f106";
}

.theia-search-button-close:before {
  content: "\\f00d";
}

.theia-search-button-close:hover:before {
  content: "\\f00d";
}

.theia-non-selectable {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/search-box.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,sCAAsC;EACtC;8BAC4B;EAC5B,0DAA0D;EAC1D,sDAAsD;EACtD,6CAA6C;EAC7C,wCAAwC;EACxC,wDAAwD;AAC1D;;AAEA;EACE;4CAC0C;AAC5C;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-search-box-padding: 3px;\n  --theia-search-box-radius: 2px;\n  --theia-search-box-spacing: 4px;\n  --theia-search-box-max-width: 500px;\n}\n\n.theia-search-box {\n  position: absolute;\n  display: flex;\n  top: var(--theia-search-box-spacing);\n  right: var(--theia-search-box-spacing);\n  box-shadow: var(--theia-border-width) var(--theia-border-width)\n    var(--theia-widget-shadow);\n  background-color: var(--theia-listFilterWidget-background);\n  z-index: calc(var(--theia-tabbar-toolbar-z-index) + 1);\n  border-radius: var(--theia-search-box-radius);\n  padding: var(--theia-search-box-padding);\n  border: var(--theia-border-width) solid rgba(0, 0, 0, 0);\n}\n\n.theia-search-box.no-match {\n  border: var(--theia-border-width) solid\n    var(--theia-inputValidation-errorBorder);\n}\n\n.theia-search-input {\n  flex-grow: 1;\n  user-select: none;\n}\n\n.theia-search-box > .theia-search-buttons-wrapper {\n  max-width: 0px;\n  transition: max-width 0.2s ease-out;\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n}\n\n.theia-search-box:hover > .theia-search-buttons-wrapper {\n  max-width: var(--theia-search-box-max-width);\n  transition: max-width 0.2s ease-in;\n}\n\n.theia-search-button {\n  min-width: 1rem;\n  text-align: center;\n  flex-grow: 0;\n  font-family: FontAwesome;\n  font-size: calc(var(--theia-content-font-size) * 0.8);\n  color: var(--theia-editorWidget-foreground);\n}\n\n.theia-search-button.codicon.codicon-filter {\n  color: var(--theia-editorWidget-foreground);\n  align-self: flex-end;\n  margin-left: var(--theia-search-box-spacing);\n}\n\n.theia-search-button.codicon-filter:not(.filter-active):before {\n  content: \"\\eb85\";\n}\n\n.theia-search-button.codicon-filter.filter-active:before {\n  content: \"\\eb83\";\n}\n\n.theia-search-button-next:before {\n  content: \"\\f107\";\n}\n\n.theia-search-button-next:hover,\n.theia-search-button-previous:hover,\n.theia-search-button-close:hover,\n.theia-search-button.codicon-filter:hover {\n  cursor: pointer;\n}\n\n.theia-search-button-next:hover:before {\n  content: \"\\f107\";\n}\n\n.theia-search-button-previous:before {\n  content: \"\\f106\";\n}\n\n.theia-search-button-previous:hover:before {\n  content: \"\\f106\";\n}\n\n.theia-search-button-close:before {\n  content: \"\\f00d\";\n}\n\n.theia-search-button-close:hover:before {\n  content: \"\\f00d\";\n}\n\n.theia-non-selectable {\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
